import axios from 'axios';
import { message } from 'antd';

const handleUnauthorized = (messageText) => {
  const hint = messageText || '登录已过期，请重新登录';
  message.error(hint);
  localStorage.removeItem('merchantToken');
  localStorage.removeItem('merchantUserInfo');
  localStorage.removeItem('merchantApps');
  localStorage.removeItem('currentAppId');
  window.location.href = '/merchant/login';
};

const merchantApi = axios.create({
  baseURL: '/api/v1',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

merchantApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('merchantToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    const currentAppId = localStorage.getItem('currentAppId');
    if (currentAppId) {
      config.headers['x-app-id'] = currentAppId;
    }
    config.headers['X-Request-ID'] = Date.now().toString();
    return config;
  },
  (error) => Promise.reject(error)
);

merchantApi.interceptors.response.use(
  (response) => {
    const { data } = response;
    if (data.code === 200) {
      return data;
    }
    if (data.code === 10002) {
      handleUnauthorized(data.message);
      return Promise.reject(new Error(data.message || '未授权访问'));
    }
    message.error(data.message || '请求失败');
    return Promise.reject(new Error(data.message || '请求失败'));
  },
  (error) => {
    const { response } = error;
    if (response?.data?.code === 10002) {
      handleUnauthorized(response.data.message);
      return Promise.reject(new Error(response.data.message || '未授权访问'));
    }
    if (response?.status === 401) {
      handleUnauthorized(response?.data?.message);
    } else if (response?.status === 403) {
      message.error('没有权限访问');
    } else if (response?.status === 404) {
      message.error('接口不存在');
    } else {
      message.error(response?.data?.message || '网络连接失败');
    }
    return Promise.reject(error);
  }
);

export const get = (url, params) => merchantApi.get(url, { params });
export const post = (url, data) => merchantApi.post(url, data);
export const put = (url, data) => merchantApi.put(url, data);
export const del = (url, params) => merchantApi.delete(url, { params });

export const setMerchantToken = (token) => {
  localStorage.setItem('merchantToken', token);
};

export const getMerchantToken = () => {
  return localStorage.getItem('merchantToken');
};

export const setMerchantApps = (apps) => {
  localStorage.setItem('merchantApps', JSON.stringify(apps));
};

export const getMerchantApps = () => {
  const apps = localStorage.getItem('merchantApps');
  return apps ? JSON.parse(apps) : [];
};

export const setCurrentAppId = (appId) => {
  localStorage.setItem('currentAppId', appId);
};

export const getCurrentAppId = () => {
  return localStorage.getItem('currentAppId');
};

export const clearMerchantAuth = () => {
  localStorage.removeItem('merchantToken');
  localStorage.removeItem('merchantUserInfo');
  localStorage.removeItem('merchantApps');
  localStorage.removeItem('currentAppId');
};

export default merchantApi;
